// ── Pure helper: pick a Polymarket spread that matches a Kalshi line ─
//
// The events map in marketStore groups one Kalshi spread per line per
// event (Kalshi encodes "team X covers" via the YES side of a single
// market), whereas Polymarket exposes one slug per side per line —
// `PM-...-spread-home-5pt5` and `PM-...-spread-away-5pt5` are two
// SEPARATE markets with two SEPARATE asset_id pairs.
//
// The matcher must align on BOTH magnitude AND side. Matching only
// magnitude can attach the wrong-side poly book to the Kalshi spread
// row — the user clicks "LAL covers -5.5" and the modal sends a token
// for "BOS covers +5.5" instead, a different bet entirely.
//
// `favored` is the Kalshi side that's covering (the YES outcome of
// the Kalshi spread market). Pick the poly spread whose slug side
// matches — i.e. `spread-away` for an away-favored Kalshi spread.

export interface PolySpread {
  ticker: string;
  line: number;
  side: 'home' | 'away';
}

export function matchPolySpread(
  polySpreads: ReadonlyArray<PolySpread>,
  lineMag: number,
  favored: 'home' | 'away',
  tolerance: number = 0.25,
): PolySpread | undefined {
  return polySpreads.find(
    (p) => p.side === favored && Math.abs(p.line - lineMag) <= tolerance,
  );
}
